import Axios from '../plugins/axios'
import fraccionService from '../services/FraccionService'
//prod
let apiUrl = 'https://enjambrec.ugto.mx/RG/Transparencia/'
//Local
//let apiUrl = 'https://localhost:44340/'
//des
//let apiUrl = 'https://colmenac.ugto.mx/rg/Transparencia/'
// Axios Configuration


export default {
    // exampleService: new exampleService(Axios),
    fraccionService: new fraccionService(Axios, apiUrl),
    servicios: [],
    categorias: []
}